import Header from '../../components/Header';
import OwnerSidebar from '../../components/owner/OwnerSidebar';
import SalesTab from '../../components/owner/SalesTab';

const SalesScreen = () => {

  return (
    <>

      <section className='dashboard-container flex '>
        <aside className=''>
        <OwnerSidebar/>
        </aside>
        <main className='main-container mb-32'>
            <Header orderTitle={'Sales'} orderSubtitle={'View sales activity on the platform'} showButton={false} /> 
          <section className='mt-10 flex gap-5'>
                 <SalesTab /> 
          </section>
        </main>
      </section>

    </>
  )
}
export default SalesScreen